<template>
  <div
    class="d-flex pa-0 flex-column align-center flex-sm-row justify-space-between"
  >
    <v-alert
      class="text-white font-weight-bold text-body-2 rounded-xl"
      :class="{ 'no-border': !isMobile }"
      dense
      color="#CF6679"
    >
      {{ pendingPayments ? 'Tienes ' + pendingPayments : 'No tienes' }}
      documentos pendientes por aplicar
    </v-alert>
    <div class="d-flex flex-row align-center">
      <span class="d-flex d-inline align-center ma-2 mr-auto">
        <v-icon size="30" class="mr-1">mdi-cash-multiple</v-icon>Facturación:
      </span>
      <custom-select
        v-model="billingType"
        class="ml-2"
        value="1"
        :options="[
          { value: '1', label: 'Trimestral' },
          { value: '2', label: 'Mensual' },
        ]"
        :placeholder="'Trimestral'"
        @input="$emit('billingTypeChange', $event)"
      />
    </div>
    <search-input
      v-model="search"
      class="mb-0"
      search-input-class="text-uppercase"
      :with-reset-button="true"
      label="Buscar Cliente"
    />
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import CustomSelect from '@/components/CustomSelect.vue';
  import SearchInput from '@/components/SearchInput.vue';

  export default {
    name: 'CustomerToolbar',
    components: {
      CustomSelect,
      SearchInput,
    },
    props: {
      pendingPayments: {
        type: String,
      },
    },
    data() {
      return {
        billingType: '1',
        search: '',
      };
    },
    computed: {
      isMobile() {
        return (
          this.$vuetify.breakpoint.name === 'sm' ||
          this.$vuetify.breakpoint.name === 'xs'
        );
      },
    },
    watch: {
      search(value) {
        this.$emit('search', value);
      },
    },
  };
</script>
